export enum TreeStatusEnum {
  COLLAPSED = 'collapsed',
  EXPANDED = 'expanded',
  LOADING = 'loading',
  DISABLED = 'disabled'
}
